<template>
  <div class="building-info-wrapper">
    <!-- Eventuell vänstersida eller tomt utrymme -->
    <div class="left-space"></div>

    <!-- Kolumn 1 -->
    <div class="building-info">
      <div class="field">
        <label class="label">{{ $t('buildinginfo.prop_name') }}</label>
        <div class="control">
          <input
            type="text"
            v-model="building.name"
            class="input"
            :placeholder="$t('buildinginfo.prop_name_ph')"
            :disabled="!$isAllowedTo('buildings_edit')"
          />
        </div>
      </div>
      <div class="field">
        <label class="label">{{ $t('buildinginfo.owner') }}</label>
        <div class="control">
          <input
            type="text"
            v-model="building.owner"
            class="input"
            :placeholder="$t('buildinginfo.owner_ph')"
            :disabled="!$isAllowedTo('buildings_edit')"
          />
        </div>
      </div>
      <div class="field">
        <label class="label">{{ $t('buildinginfo.customer') }}</label>
        <div v-if="customers.length > 0">
          <select
            v-model="selectedRootCustomerId"
            class="input"
            :disabled="!$isAllowedTo('buildings_edit')"
            disabled
          >
            <option value="" disabled>{{ $t('buildinginfo.select_customer') }}</option>
            <option
              v-for="customer in rootCustomers"
              :key="customer.id"
              :value="customer.id"
            >
              {{ customer.name }}
            </option>
          </select>
        </div>
        <div v-else></div>
        <div>
          <div class="field" v-if="allDescendants.length > 0">
            <label class="label">{{ $t('buildinginfo.department') }}</label>
            <div class="control">
              <select
                v-model="selectedChildCustomerId"
                class="input"
                :disabled="!$isAllowedTo('buildings_edit')"
                disabled
              >
                <option value="" disabled>{{ $t('buildinginfo.select_department') }}</option>
                <option v-for="child in allDescendants" :key="child.id" :value="child.id">
                  {{ child.name }}
                </option>
              </select>
            </div>
          </div>
          <div v-else></div>
        </div>

        <div class="field">
          <label class="label">{{ $t('buildinginfo.contact_person') }}</label>
          <div class="control">
            <input
              type="text"
              v-model="building.contactPerson"
              class="input"
              :placeholder="$t('buildinginfo.contact_person_ph')"
              :disabled="!$isAllowedTo('buildings_edit')"
            />
          </div>
        </div>
        <div class="field">
          <label class="label">{{ $t('buildinginfo.contact_phone') }}</label>
          <div class="control">
            <input
              type="text"
              v-model="building.contactPhone"
              class="input"
              :placeholder="$t('buildinginfo.contact_phone_ph')"
              :disabled="!$isAllowedTo('buildings_edit')"
            />
          </div>
        </div>

        <div class="field">
          <label class="label">{{ $t('buildinginfo.visit_address') }}</label>
          <div class="control">
            <input
              type="text"
              v-model="building.visitAddress"
              class="input"
              :placeholder="$t('buildinginfo.visit_address_ph')"
              :disabled="!$isAllowedTo('buildings_edit')"
            />
          </div>
        </div>

        <div class="field">
          <label class="label">{{ $t('buildinginfo.zip_city') }}</label>
          <div class="control zip-city-row">
            <input
              type="text"
              v-model="building.visitAddressZipCode"
              class="input zip-code"
               :placeholder="$t('buildinginfo.zip_ph')"
              :disabled="!$isAllowedTo('buildings_edit')"
            />
            <input
              type="text"
              v-model="building.visitAddressCity"
              class="input city"
              :placeholder="$t('buildinginfo.city_ph')"
              :disabled="!$isAllowedTo('buildings_edit')"
            />
          </div>
        </div>

        <div class="field">
          <label class="label">{{ $t('buildinginfo.activity_type') }}</label>
          <div class="control">
            <input
              type="text"
              v-model="building.activityType"
              class="input"
              :placeholder="$t('buildinginfo.activity_type_ph')"
              :disabled="!$isAllowedTo('buildings_edit')"
            />
          </div>
        </div>

        <div class="field">
          <label class="label">{{ $t('buildinginfo.built_year') }}</label>
          <div class="control">
            <input
              type="number"
              v-model="building.builtYear"
              class="input"
              :placeholder="$t('buildinginfo.built_year_ph')"
              :disabled="!$isAllowedTo('buildings_edit')"
            />
          </div>
        </div>

        <div class="field">
          <label class="label">{{ $t('buildinginfo.no_employees') }}</label>
          <div class="control">
            <input
              type="number"
              v-model="building.noOfEmployees"
              class="input"
              :placeholder="$t('buildinginfo.no_employees_ph')"
              :disabled="!$isAllowedTo('buildings_edit')"
            />
          </div>
        </div>

        <div class="field">
          <label class="label">{{ $t('buildinginfo.total_area') }}</label>
          <div class="control">
            <input
              type="number"
              v-model="building.totalArea"
              class="input"
              :placeholder="$t('buildinginfo.total_area_ph')"
              :disabled="!$isAllowedTo('buildings_edit')"
            />
          </div>
        </div>

        <div class="field">
          <label class="label">{{ $t('buildinginfo.no_floors') }}</label>
          <div class="control">
            <input
              type="text"
              v-model="building.noOfFloor"
              class="input"
              :placeholder="$t('buildinginfo.no_floors_ph')"
              :disabled="!$isAllowedTo('buildings_edit')"
            />
          </div>
        </div>

        <div class="field">
          <label class="label">{{ $t('buildinginfo.position') }}</label>
          <div class="control">
            <input
              type="text"
              v-model="building.position"
              class="input"
              :placeholder="$t('buildinginfo.position_ph')"
              :disabled="!$isAllowedTo('buildings_edit')"
            />
          </div>
        </div>

        <div class="field">
          <label class="label">{{ $t('buildinginfo.other') }}</label>
          <div class="control">
            <textarea
              rows="3"
              cols="10"
              v-model="building.other"
              class="textarea"
              :placeholder="$t('buildinginfo.other_ph')"
              :disabled="!$isAllowedTo('buildings_edit')"
            ></textarea>
          </div>
        </div>

        <!-- <div class="field checkbox-inline">
  <label class="label">	Gammal ritningsstorlek	</label>
  <div class="control">
    <input type="checkbox" v-model="building.useOldDrawing" :disabled="!$isAllowedTo('buildings_edit')" class="small-checkbox" />
  </div>
</div> -->

       <!--  <div class="field checkbox-inline">
          <label class="label">Serviceavtal</label>
          <div class="control">
            <input
              type="checkbox"
              v-model="building.serviceAgreement"
              :disabled="!$isAllowedTo('buildings_edit')"
              class="small-checkbox"
            />
          </div>
        </div>
        -->

        <div class="field">
          <label class="label">
            {{ $t('buildinginfo.service_info_label') }}</label
          >
          <div class="control">
            <textarea
              rows="3"
              cols="10"
              v-model="building.serviceInfo"
              class="textarea"
              :placeholder="$t('buildinginfo.service_info_ph')"
              :disabled="!$isAllowedTo('buildings_edit')"
            ></textarea>
          </div>
        </div>
        <div class="field language-selection">
          <!--  <div class="control">
            <label class="label">Dokument språk</label>
            <label class="radio-inline">
              <input
                type="radio"
                value="1"
                v-model="building.languageId"
                :disabled="!$isAllowedTo('buildings_edit')"
              />
              Svenska
            </label>
            <label class="radio-inline">
              <input
                type="radio"
                value="2"
                v-model="building.languageId"
                :disabled="!$isAllowedTo('buildings_edit')"
              />
              Engelska
            </label>
            <br />
            <br />
          </div> -->
          <div class="field" style="display: flex; justify-content: flex-end">
            <div class="control">
              <button
                class="button is-info"
                @click="saveBuilding"
                v-if="$isAllowedTo('buildings_edit')"
              >
                <span class="icon is-white"><i class="fas fa-save" /></span
                ><span>{{ $t('buildinginfo.save') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "BuildingInfo",
  props: {
    building: {
      type: Object,
      required: true,
    },
  },
  computed: {
    customers() {
      return this.$store.state.customerStore.dropdownCustomers || [];
    },
    rootCustomers() {
      return this.customers;
    },
    selectedRootCustomerId: {
      get() {
        const parentId = this.building.customer?.parentId;
        if (!parentId) {
          return this.building.customer?.id || "";
        }
        const root = this.findRootCustomerByChildId(parentId);
        return root ? root.id : "";
      },
      set(value) {
        if (!this.building.customer) {
          this.$set(this.building, "customer", {});
        }
        this.$set(this.building.customer, "parentId", value);
      },
    },
    allDescendants() {
      const root = this.rootCustomers.find((c) => c.id === this.selectedRootCustomerId);
      if (!root) return [];
      return this.getAllDescendantsWithLevel(root);
    },
    selectedChildCustomerId: {
      get() {
        return this.building.customer?.id || "";
      },
      set(value) {
        if (!this.building.customer) {
          this.$set(this.building, "customer", {});
        }
        this.$set(this.building.customer, "id", value);
      },
    },
  },

  watch: {
    selectedRootCustomerId(newVal, oldVal) {
      if (newVal !== oldVal) {
        // Om child id inte tillhör den nya roten, nollställ child id
        const childId = this.building.customer?.id;
        if (
          childId &&
          !this.findCustomerInTree(
            this.rootCustomers.find((c) => c.id === newVal),
            childId
          )
        ) {
          this.$set(this.building.customer, "id", null);
        }
      }
    },
  },
  methods: {
    ...mapActions("buildingStore", ["updateBuilding"]),
    ...mapActions("customerStore", ["getAllCustomers"]),

    saveBuilding() {
      if (this.selectedChildCustomerId) {
        // Underavdelning vald
        if (!this.building.customer) {
          this.$set(this.building, "customer", {});
        }
        this.$set(this.building.customer, "id", this.selectedChildCustomerId);
        this.$set(this.building.customer, "parentId", this.selectedRootCustomerId);
      } else {
        // Ingen underavdelning vald
        if (!this.building.customer) {
          this.$set(this.building, "customer", {});
        }
        this.$set(this.building.customer, "id", this.selectedRootCustomerId);
        this.$set(this.building.customer, "parentId", null);
      }

      this.updateBuilding(this.building);
    },

    findCustomerInTree(customer, id) {
      if (customer.id === id) return true;
      if (!customer.children) return false;
      for (const child of customer.children) {
        if (this.findCustomerInTree(child, id)) {
          return true;
        }
      }
      return false;
    },

    findRootCustomerByChildId(id) {
      for (const rootCustomer of this.customers) {
        if (this.findCustomerInTree(rootCustomer, id)) {
          return rootCustomer;
        }
      }
      return null;
    },

    getAllDescendantsWithLevel(customer, level = 0, list = []) {
      if (!customer.children || customer.children.length === 0) return list;

      customer.children.forEach((child) => {
        list.push({
          id: child.id,
          name: `${"— ".repeat(level)}${child.name}`,
        });
        this.getAllDescendantsWithLevel(child, level + 1, list);
      });

      return list;
    },
  },
  async mounted() {
    try {
      await this.getAllCustomers();
    } catch (error) {
      console.error("Error loading customers:", error);
    }
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/colors.scss";

.building-info-wrapper {
  display: flex;
  justify-content: left; // Centrera horisontellt
  align-items: center; // Centrera vertikalt (kräver att förälder har höjd)
  min-height: 100vh; // Gör wrapper minst lika hög som viewport

  box-sizing: border-box;
}

.left-space {
  display: none; // Ta bort vänsterspalt för ren centrering
}

.building-info {
  width: 100%;
  max-width: 500px; // Maxbredd för att inte sträcka sig för mycket
  display: flex;
  flex-direction: column;
  gap: 1px;
  background: #fff; // Bakgrund om du vill ha vit ruta
  padding: 1rem;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); // Valfritt
}

.field {
  .label {
    font-size: 12px;
    font-weight: bold;
  }

  .input {
    background: white;
    border-radius: 2px;
    width: 100%;
  }
}
.zip-city-row {
  display: flex;
  gap: 12px; // Lite mellanrum mellan fälten
}

.zip-code {
  flex: 0 0 25%; // 25% av bredden
}

.city {
  flex: 1; // Tar upp resterande plats (75%)
}
@media (max-width: 600px) {
  .zip-city-row {
    flex-direction: column;
  }

  .zip-code,
  .city {
    flex: 1 1 100%;
  }
}
.checkbox-inline {
  display: flex;
  align-items: center;
  gap: 20px; // Avstånd mellan etikett och checkbox
}

.checkbox-inline .label {
  margin: 0; // Ta bort ev. marginal
  font-size: 12px;
}

.small-checkbox {
  margin-top: 0.4rem;
  transform: scale(1.2); // Gör checkboxen mindre
  cursor: pointer;
}
.language-selection .control {
  display: flex;
  gap: 20px;
  align-items: center;
}

.radio-inline {
  margin-top: -0.4rem;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 10px;
  cursor: pointer;
  user-select: none;
}

.radio-inline input[type="radio"] {
  transform: scale(1);
  cursor: pointer;
}
</style>
